import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ProductCartView from '../components/Product/ProductCartView';
import ProductCartRecapView from '../components/Product/ProductCartRecapView';
import _ from 'lodash';
import {withRouter} from 'react-router-dom';
import * as basketActions from '../actions/basketActions';
import * as orderActions from '../actions/orderActions';
import {
  actionWrapper,
  calcCostDeal,
  calcCostPizza,
  calcCostProduct,
  getOrderPeriod,
} from '../helpers';
import * as restaurantActions from '../actions/restaurantActions';
import * as userActions from '../actions/userActions';
import * as appActions from '../actions/appActions';
import classNames from 'classnames';
import {DEFAULT_LIFETIME_ORDER_COOKING_TIME, DEFAULT_SIZE_PIZZA, DEFAULT_LANGUAGE} from '../constants';
import moment from 'moment/moment';
import {translate} from 'react-i18next';
import {confirmAlert} from 'react-confirm-alert';
import ReactDOM from 'react-dom';

class BasketLayout extends Component {

  constructor(props) {
    super(props);
    this.handleLocationChange = this.handleLocationChange.bind(this);

    this.calcTimeLeft = this.calcTimeLeft.bind(this);
    this.registerUser = this.registerUser.bind(this);
    this.checkIsClosedRestaurant = this.checkIsClosedRestaurant.bind(this);
    this.validateOrder = this.validateOrder.bind(this);
    this.confirmOrder = this.confirmOrder.bind(this);
    this.checkOrderTime = this.checkOrderTime.bind(this);
    this.createOrder = this.createOrder.bind(this);
    this.increase = this.increase.bind(this);
    this.decrease = this.decrease.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.calcTimeDifferenceTime = this.calcTimeDifferenceTime.bind(this);
    this.state = {
      inProgress: false,
      timeLeft: 1,
      errors: {},
    };
    this.refRegistration = React.createRef();
  }

  componentDidMount() {
    const {history} = this.props;
    this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
    this.handleLocationChange(history.location);

    this.initTimeCounter();
  }

  componentDidUpdate(prevProps) {
    const {selectedTime} = this.props;

    if (prevProps.selectedTime.value !== selectedTime.value) {
      this.calcTimeLeft(true);
    }
  }

  componentWillUnmount() {
    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
    if (this.timeCounterInteval) clearInterval(this.timeCounterInteval);
  }

  handleLocationChange(location) {
    if (this.props.location.pathname !== location.pathname && this.props.basket.openedBasket) {
      this.props.closeBasket();
    }
  }

  initTimeCounter() {
    this.calcTimeLeft(true);
    this.timeCounterInteval = setInterval(() => {
      const {timeLeft} = this.state;
      if (timeLeft >= 0) {
        this.setTimeLeft(timeLeft - 1);
      }
    }, 1000);
  }

  setTimeLeft(seconds) {
    this.setState({
      timeLeft: seconds,
    });
  }

  registerUser(data) {
    this.setState({
      errors: {},
    });
    actionWrapper(this, data, this.props.registerUser).catch(() => {
      const formNode = ReactDOM.findDOMNode(this.refRegistration.current);
      formNode.scrollIntoView(true);
    });
  }

  getBasketListAndCost() {
    const {restaurant, basket, ingredients} = this.props;
    let result = [], total = 0;
    _.forEach(basket.list, (value, index) => {
      let cost = 0,
          crustName = '',
          info = {},
          additionalOptionProduct = {};
      const key = value.type;
      const id = value ? value.productId : -1;
      if (key === 'pizza') {
        info = _.find(restaurant.pizzas, {id: id});
        if (info) {

          let crustId = value.crustID;
          let option = _.find(info.options,
              obj => obj.crust.id === parseInt(crustId, 10) && obj[value.size]);
          if (!option && info.options.length > 0) {
            option = _.find(info.options, op => op.crust && op[value.size || DEFAULT_SIZE_PIZZA]);
            crustId = option.crust.id;
          }

          cost = parseFloat(
              (calcCostPizza(info, crustId,
                  value.size, value.quantity, ingredients, value.extraIngredientsMinus,
                  value.extraIngredientsPlus)).toFixed(2),
          );
          if (option) {
            crustName = option.crust[`name_${this.props.language}`];
          }
          additionalOptionProduct = {
            crustID: crustId,
            crustName: crustName,
            sauceID: value.sauceID || info.sauce.id,
            size: value.size || DEFAULT_SIZE_PIZZA,
            extraIngredientsMinus: value.extraIngredientsMinus || [],
            extraIngredientsPlus: value.extraIngredientsPlus || [],
            typeProduct: 'pizza',
          };
        }
      } else if (key === 'product') {
        info = _.find(restaurant.products, {id: id});
        if (info) {
          cost = parseFloat((calcCostProduct(info, value.optionQuantity,
              value.quantity)).toFixed(2));
          additionalOptionProduct = {
            optionQuantity: value.optionQuantity,
            sauceID: value.sauceID,
            typeProduct: 'product',
          };
        }
      } else {
        info = _.find(restaurant.deals, {id: id});
        if (info) {
          cost = parseFloat(calcCostDeal(info, value.quantity));
          additionalOptionProduct = {
            typeProduct: 'deals',
            options: value.options,
          };
        }
      }
      total += cost;
      if (info) {
        result.push({
          quantity: value.quantity || info.quantity,
          cost: cost,
          index: index,
          product: info,
          productId: info.id,
          ...additionalOptionProduct,
        });
      } else {
        this.onRemove(key, index);
      }
    });
    return {
      basketList: result,
      totalCost: total,
    };
  }

  onRemove(type, index) {
    this.props.removeFromCard({
      type: type,
      index: index
    });
  };

  calcTimeDifferenceTime(time, selectedTime, defaultOrderTime) {
    let currentTime = time ? moment(time, 'HH:mm:ss') : moment();
    const difference = moment(selectedTime.value, 'HHmm').diff(currentTime, 'seconds') -
        defaultOrderTime * 60;

    this.setTimeLeft(difference);
  }

  calcTimeLeft(reGetServerTime=false) {
    let {selectedTime, restaurant, getServerTime, serverTime} = this.props;

    if (!_.isEmpty(selectedTime)) {
      let defaultOrderTime = getOrderPeriod(restaurant);
      if (reGetServerTime) {
        getServerTime().then(response => {
          this.calcTimeDifferenceTime(response.data.time, selectedTime, defaultOrderTime);
        });
      } else {
        this.calcTimeDifferenceTime(serverTime, selectedTime, defaultOrderTime);
      }
    }
  }

  createOrder(data) {
    const {createOrder, basket, selectedTime, language} = this.props;
    return createOrder({
      ...data,
      detail: basket,
      selectedTime: selectedTime.label,
      language: language
    });
  }

  checkOrderTime() {
    const {getOrderTimeCooking, restaurant, updateRestaurantOrderTime, t, selectedTime} = this.props;
    return getOrderTimeCooking(restaurant.id).then((response) => {
      const {order_period, order_period_modified} = response.data;
      if (moment(selectedTime.value, 'HHmm').diff(moment(), 'minutes') < order_period &&
          order_period_modified && moment(order_period_modified)
              .add(DEFAULT_LIFETIME_ORDER_COOKING_TIME || 2, 'hours')
              .isAfter(moment())) {
        confirmAlert({
          message: t('many_orders'),
          buttons: [
            {
              label: t('continue'),
              onClick: () => updateRestaurantOrderTime({
                ...restaurant,
                order_period,
                order_period_modified,
              }),
            },
          ],
        });
        return Promise.reject(false);
      }
      return Promise.resolve(true);
    });
  }

  confirmOrder(data) {
    const {clearBasket, closeBasket, history, profile, restaurant, language} = this.props;
    actionWrapper(this, data, this.confirmOrderHandler.bind(this)).then((response) => {
      const responseData = response.data;
      if (responseData.payment === 'card' && responseData.transaction) {
        if (responseData.transaction.redirect_url) {
          localStorage.setItem("pickUpTimeLabel", responseData.detail.selectedTime);
          window.location = responseData.transaction.redirect_url;
        }
        else {
          this.setState({errors: {'saferpay': true}});
          return Promise.reject(false);
        }
      } else {
        clearBasket();
        closeBasket();
        const lng = language || DEFAULT_LANGUAGE;
        history.push({
          pathname: `/${lng}/order/confirm`,
          state: {
            'orderId': responseData.id,
            'orderTime': responseData.detail.selectedTime,
            'userEmail': profile.get('email'),
            'restaurantName': restaurant.name,
            'amount': responseData.amount,
            'result': responseData.extra_detail.result
          }
        });
      }
      return Promise.resolve(true);
    }).catch(() => {
      if (!_.isUndefined(this.state.errors.micros)
        || !_.isUndefined(this.state.errors.vectron)
        || !_.isUndefined(this.state.errors.celery)) {
        const lng = language || DEFAULT_LANGUAGE;
        this.props.history.push(`/${lng}/pity`);
      }
    })
  }

  confirmOrderHandler(data) {
    const {createOrder, checkIsClosedRestaurant} = this;
    return checkIsClosedRestaurant().then(this.checkOrderTime).then(() => createOrder(data));
  };

  checkIsClosedRestaurant() {
    const {restaurant, t, checkRestaurantIsClosed} = this.props;
    return checkRestaurantIsClosed(restaurant.id, t);
  }

  validateOrder() {
    this.checkIsClosedRestaurant().then(() => this.props.history.push(`/${this.props.language}/${this.props.restaurant.name_for_url}/recap`));
  }

  increase(obj) {
    const value = obj.quantity + 1;
    this.updateQuantity(value, obj);
  }

  decrease(obj) {
    const value = obj.quantity - 1 ? obj.quantity - 1 : 1;
    this.updateQuantity(value, obj);
  }

  updateQuantity(value, obj) {
    this.props.updateBasket({
      category: obj.typeProduct,
      index: obj.index,
      quantity: value,
    });
  }

  render() {
    const {openedBasket, recap, restaurant, language, clearBasket, ingredients, closeBasket, restaurantSelect, profile, openBasket, t} = this.props;
    const {timeLeft, inProgress, errors} = this.state;
    const {basketList, totalCost} = this.getBasketListAndCost();
    return (<div className={classNames('products__cart',
      {'products__cart--visible': openedBasket},
    )}>
      {!recap ?
        <ProductCartView
          restaurant={restaurant}
          language={language}
          basketList={basketList}
          totalCost={totalCost}
          onRemove={this.onRemove}
          increase={this.increase}
          decrease={this.decrease}
          clearBasket={clearBasket}
          closeBasket={closeBasket}
          restaurantChange={restaurantSelect}
          ingredients={ingredients}
          validateOrder={this.validateOrder}
          timeLeft={timeLeft}
        />
        :
        <ProductCartRecapView
          restaurant={restaurant}
          basketList={basketList}
          totalCost={totalCost}
          onRemove={this.onRemove}
          increase={this.increase}
          decrease={this.decrease}
          language={language}
          logged={!profile.isEmpty()}
          ingredients={ingredients}
          timeLeft={timeLeft}
          refRegistration={this.refRegistration}
          registerUser={this.registerUser}
          inProgress={inProgress}
          errors={errors}
          closeBasket={closeBasket}
          confirmOrder={this.confirmOrder}
        />
      }
      {!openedBasket &&
      <button className="products__cart-toggler" onClick={openBasket}>
        {t('cart')} {basketList.length} {(basketList.length === 1 ? t('item') : t('items'))}
      </button>
      }
    </div>);
  }
}

BasketLayout.propTypes = {
  recap: PropTypes.bool,
};

function mapStateToProps(state) {
  state.basket.list = _.orderBy(state.basket.list, 'index', ['desc']);
  return {
    restaurant: state.restaurants.item,
    ingredients: state.products.ingredients.toArray(),
    basket: state.basket,
    openedBasket: state.basket.openedBasket,
    profile: state.user.get('profile'),
    language: state.language.defaultLanguage,
    selectedTime: state.pickUpTime.selectedOption,
    serverTime: state.pickUpTime.serverTime
  };
}

function mapDispatchToProps(dispatch) {
  return {
    removeFromCard: bindActionCreators(basketActions.removeFromCard, dispatch),
    updateBasket: bindActionCreators(basketActions.updateBasket, dispatch),
    clearBasket: bindActionCreators(basketActions.clearBasket, dispatch),
    createOrder: bindActionCreators(orderActions.createOrder, dispatch),
    restaurantSelect: bindActionCreators(restaurantActions.selectedRestaurant, dispatch),
    getOrderTimeCooking: bindActionCreators(restaurantActions.getOrderTimeCooking, dispatch),
    checkRestaurantIsClosed: bindActionCreators(restaurantActions.checkRestaurantIsClosedNow,
        dispatch),
    updateRestaurantOrderTime: bindActionCreators(restaurantActions.updateRestaurantOrderTime,
        dispatch),
    openBasket: bindActionCreators(basketActions.openBasket, dispatch),
    closeBasket: bindActionCreators(basketActions.closeBasket, dispatch),
    registerUser: bindActionCreators(userActions.registerUser, dispatch),
    getServerTime: bindActionCreators(appActions.getServerTime, dispatch),
  };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(translate('translations')(BasketLayout)));



// WEBPACK FOOTER //
// ./src/containers/Basket.js